// extracted by mini-css-extract-plugin
export var Evergreen = "TabbedContent-module--Evergreen--75ab2";
export var Lilac = "TabbedContent-module--Lilac--86a96";
export var Pink = "TabbedContent-module--Pink--be8d1";
export var activeTab = "TabbedContent-module--active-tab--9ed98";
export var content = "TabbedContent-module--content--e8708";
export var dropDown = "TabbedContent-module--drop-down--16b71";
export var fadeIn = "TabbedContent-module--fadeIn--ae1a8";
export var heading = "TabbedContent-module--heading--e12eb";
export var hidden = "TabbedContent-module--hidden--8ba45";
export var logo = "TabbedContent-module--logo--224ed";
export var pill = "TabbedContent-module--pill--4348c";
export var section = "TabbedContent-module--section--0c890";
export var tab = "TabbedContent-module--tab--c1758";
export var tabContainer = "TabbedContent-module--tab-container--91223";
export var tabContainerMobile = "TabbedContent-module--tab-container-mobile--36abe";
export var tabContent = "TabbedContent-module--tab-content--a1299";
export var tabs = "TabbedContent-module--tabs--0b936";